import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from '../environments/environment';
import { NotificationSocketService } from './service/notification-socket.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  private messaging: any;

  constructor(private notifSocket: NotificationSocketService) {
    if (environment.firebaseConfig) {
      try {
        const app = initializeApp(environment.firebaseConfig);
        this.messaging = getMessaging(app);
      } catch (e) {
        console.error('Firebase initialization error', e);
      }
    }
  }

  async requestToken(): Promise<string | null> {
    if (!this.messaging) return null;

    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        let registration;
        if ('serviceWorker' in navigator) {
          const configStr = encodeURIComponent(JSON.stringify(environment.firebaseConfig));
          registration = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?firebaseConfig=${configStr}`);
        }

        const token = await getToken(this.messaging, {
          serviceWorkerRegistration: registration,
          vapidKey: environment.firebaseConfig.vapidKey
        });
        if (token) {
          return token;
        } else {
          console.log('No registration token available. Request permission to generate one.');
          return null;
        }
      } else {
        console.log('Notification permission denied');
        return null;
      }
    } catch (error) {
      console.error('An error occurred while retrieving token. ');
      return null;
    }
  }

  listen() {
    if (!this.messaging) return;
    onMessage(this.messaging, (payload: any) => {
      console.log('FCM Message received. ', payload);
      // Map FCM payload to standard payload structure expected by UI
      const standardPayload = {
        title: payload.notification?.title || payload.data?.title || 'New Notification',
        body: payload.notification?.body || payload.data?.body || '',
        type: payload.data?.type || 'info',
        ...payload.data
      };
      this.notifSocket.emitNotification(standardPayload);
    });
  }
}
